import { createContext, ReactNode, useContext } from "react";

import type { TCard, TComparisonTable, TSuggestedAction } from "@/models/chat.model";

export type TSocketContext = {
  messages: IMessage[],
  sendMessage: (message: string) => void,
  setMessages: (value: (((prevState: IMessage[]) => IMessage[]) | IMessage[])) => void,
  isTyping: boolean,
  isConversationClosed: boolean,
  restartSession: () => void,
  isDebugEnabled: boolean,
  setDebugEnabled: (value: boolean) => void,
};

export type TMessageSender = "USER" | "AI" | "OPERATOR" | "SYSTEM";

export type TMessageTone = "neutral" | "success" | "warning" | "danger";

export interface IMessage {
  sender?: TMessageSender;
  type?: string;
  message: ReactNode;
  date?: Date | string;
  agentName?: string;
  cards?: TCard[];
  comparisonData?: TComparisonTable;
  suggestedActions?: TSuggestedAction[];
  seq?: number;
  label?: string;
  tone?: TMessageTone;
}

export const SocketContext = createContext<TSocketContext | null>(null);

export const useSocket = () => {
  const socket = useContext(SocketContext);

  if (!socket) {
    throw new Error("useSocket must be used within a SocketProvider");
  }

  return socket;
};
